import jwtDecode from "jwt-decode";
import { useState } from "react";
import { getCookie } from "../../utils/cookies";

const TokenDetails = () => {
  const token = getCookie("token");

  const [tokenDetails, setTokenDetails] = useState(
    token ? jwtDecode(token) : null
  );

  if (!token || token === "undefined") {
    return;
  }

  if (
    localStorage.getItem("isValidUser") === "false" ||
    localStorage.getItem("isValidUser") === false
  ) {
    return null;
  }

  if (!tokenDetails) {
    console.error("error");
  }

  const roleKey =
    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
  const emailKey =
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";

  const {
    [roleKey]: originalRole,
    [emailKey]: originalEmail,
    ...rest
  } = tokenDetails;

  return {
    ...rest,
    role: originalRole?.toLowerCase(),
    Email: originalEmail?.toLowerCase(),
  };
};

export default TokenDetails;
